module.exports = __webpack_public_path__ + "static/media/miniV1V2.f68e0a7a.png";